const ID_SEGMENT = /^([0-9a-f]{8}-[0-9a-f-]{27}|[0-9a-f]{32}|\d+)$/i

export function getRequestPathPattern(path: RequestInfo | URL) {
  const raw = typeof path === "string" || path instanceof URL ? path : path.url
  try {
    const { host, pathname } = new URL(raw, window.location.origin)
    const segments = pathname
      .split("/")
      .map(segment => (ID_SEGMENT.test(segment) ? ":id" : segment))
    return `${host}${segments.join("/")}`
  } catch {
    return "unknown"
  }
}
